angular.module('picmonicng').factory('SearchService', [
  function () {
    var defaults = {
      searching: false,
      loading: {
        initial: false,
        user: false,
        results: false,
        more: false,
      },
      pending: {
        reset: false,
        results: false,
        more: false,
      },
      searchTerm: '',
      filters: {
        root_pathways: [],
        sub_pathways: [],
      },
      selected_filters: {
        what: 'everything',
        bookmarked: false,
        pathway_type: false,
        root_pathway: false,
        sub_pathway: false,
        track: false,
        ugc: false,
      },
      focused: false,
    };

    var SearchService = {
      reset: function () {
        angular.merge(this, defaults);
      },
    };

    SearchService.reset();

    return SearchService;
  },
]);
